export default __webpack_public_path__ + "static/media/typeGreen.948582d9.svg";